import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import CartSheet from "@/components/CartSheet";
import Home from "@/pages/Home";
import OrderLookup from "@/pages/OrderLookup";
import Admin from "@/pages/Admin";

export default function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-[#FDFBF7] text-[#1F2924]">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/orders/lookup" element={<OrderLookup />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <CartSheet />
          <Toaster richColors position="top-center" />
        </div>
      </BrowserRouter>
    </CartProvider>
  );
}
